module.exports = __webpack_public_path__ + "42bfc4f3e97f3c31fda37cdf91161052.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/tomhorn/assets/154.png
// module id = 1749
// module chunks = 2